// Module
var code = `<div class="cp-auth-layout"> <div ui-view></div> </div> `;
// Exports
module.exports = code;